// @core/api/endpoints/context/register_relation_group_manifest.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RegisterRelationGroupManifestRequest,
  RegisterRelationGroupManifestResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Register relation group manifest
 * Registers or updates a relation group manifest. Caller's product_id must match manifest.owner_product_id. ResourceService calls this at startup to declare how relation types are grouped and ranked.
 */
export async function RegisterRelationGroupManifest(
  group_key: string,
  data: RegisterRelationGroupManifestRequest,
  options?: RequestOptions
): Promise<RegisterRelationGroupManifestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/context/manifests/relations/:group_key`;
  requestPath = requestPath.replace(':group_key', encodeURIComponent(group_key));
  const requestOptions = options;
  return client.put<RegisterRelationGroupManifestResponse>(requestPath, data, requestOptions);
}
